import { DynamicForm } from '../../DynamicForm';
import { Select, SelectItem } from '../../../../../components/Select';
import { Checkbox } from '../../../../../components/Checkbox';
import { SettingItemList } from '../../SettingItemList';
import { useCreateOperator } from '../../../../../contexts/CreateOperatorContext';
import { DeviceModel } from './DeviceModel';

const requiredFields: CreateDeviceModel = {
  name: '',
  clientVersion: '',
  canDVR: false,
  active: true,
  clientStoreValue: '',
};

const hosDeviceModelForm: CreateDeviceModel = {
  deviceTypeID: 0,
  manufacturer: '',
  bacEthernetSuffix: '',
  bacSuffix: '',
  bacManufacturerCode: '',
  rebootOID: '',
  snmpCommunity: '',
  ...requiredFields,
};

const resDeviceModelForm: CreateDeviceModel = {
  system: 'MR',
  ...requiredFields,
};

export const DeviceModels = () => {
  const { operator, updateOperator } = useCreateOperator();
  const classes = useStyles();

  const handleValidation = (values: CreateDeviceModel) =>
    values.name.trim() !== '' && values.clientVersion.trim() !== '';

  const handleRemove = (modelIndex: number) => {
    updateOperator(
      'deviceModels',
      operator.deviceModels.filter((value, index) => index !== modelIndex)
    );
  };

  const handleSave = (item: CreateDeviceModel, modelIndex: number) => {
    updateOperator(
      'deviceModels',
      operator.deviceModels.map((value, index) => {
        if (index === modelIndex) return item;
        return value;
      })
    );
  };

  return (
    <div className={classes.container}>
      <DynamicForm<CreateDeviceModel>
        defaultForm={resDeviceModelForm}
        inputs={[
          {
            order: 0,
            rowInputs: [
              {
                props: {
                  name: 'name',
                  label: 'Model Name',
                  required: false, // TODO: Disabling for now, Original setting: true,
                  value: (values) => values.name,
                },
              },
              {
                props: {
                  name: 'clientVersion',
                  label: 'Client Version',
                  required: false, // TODO: Disabling for now, Original setting: true,
                  value: (values) => values.clientVersion,
                },
              },
            ],
          },
          {
            order: 1,
            rowInputs: [
              {
                customInput: (values, updateField) => (
                  <Select
                    label="System"
                    onChange={(event) =>
                      updateField('system', event.target.value)
                    }
                    value={values?.system ?? ''}
                    variant="contained"
                    // TODO: Disabling for now, Original setting: required
                  >
                    <SelectItem value="MR">MediaRoom</SelectItem>
                    <SelectItem value="MF">MediaFirst</SelectItem>
                  </Select>
                ),
              },
              {
                customInput: (values, updateField) => (
                  <Checkbox
                    label="DVR?"
                    onChange={(event) =>
                      updateField('canDVR', event.target.checked)
                    }
                    checked={values.canDVR}
                  />
                ),
              },
            ],
          },
        ]}
        submitButton={{ text: 'Add Device Model' }}
        onSubmit={(values) =>
          updateOperator('deviceModels', [values, ...operator.deviceModels])
        }
        validation={handleValidation}
      />
      <SettingItemList<CreateDeviceModel>
        items={operator.deviceModels}
        name="Device Models"
        renderRow={(item, index) => (
          <DeviceModel
            index={index}
            deviceModel={item}
            onRemove={handleRemove}
            onSave={handleSave}
          />
        )}
      />
    </div>
  );
};

const useStyles = () => ({
  container: 'flex flex-col gap-4 items-center',
});
